import React from "react";
import { Container } from "./styles";
import logo from "../../images/logo.png";
import userPhoto from "../../images/user.png";
import { useAuth } from "../../hooks/AuthContext";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

export default function HeaderPublic() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <Container>
      <img src={logo} className="logo" />
      {user && (
        <div>
          <Button
            type="primary"
            onClick={() => {
              navigate(-1);
            }}
            style={{
              borderRadius: 50,
              height: 30,
              fontSize: 13,
              alignSelf: "center",
              marginRight: 25,
            }}
          >
            Voltar para a Página Anterior
          </Button>
          <button
            onClick={() => {
              navigate(
                `/${user.type == "admin" ? user.type : user.type + "s"}/perfil`
              );
            }}
          >
            <img src={user.photo ? user.photo_url : userPhoto} />
          </button>
        </div>
      )}
    </Container>
  );
}
